import { api } from "../../axios";
export const actions = {
    //FileManager
    GetFiles(context, data) {
      return api.post(`FileManager/${data.id}`, {
        type: data.type,
        removeLoading: data.removeLoading ? data.removeLoading : false
      });
    },
    UploadFile(context, data) {
      let formData = new FormData();
      formData.append("ReferenceId", data.id);
      formData.append("Type", data.type);
      formData.append("Folder", data.folder);
      formData.append("Description", data.description);
      formData.append("File", data.file);
      return api.post(`FileManager/File/Upload`, formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    DeleteFile(context, data) {
        return api.delete(`FileManager/${data}`);
    },
    DeleteFileByReference(context, data) {
      return api.delete(`FileManager/${data.referenceId}/${data.type}`);
  },
}